// extracted by mini-css-extract-plugin
export default {"navlinks":"NavBar_navlinks__fdBqe","active":"NavBar_active__dq9zA"};